import styled from 'styled-components'
import React from 'react'
import {
  AspiraRegular,
  FontSize12,
  FontSize14,
  FontSize18,
} from '@chegg-wt/core/theme/sunkist/fonts'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'

export const PageWrapper = styled.main`
  ${AspiraRegular};
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  white-space: pre-line;
`

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.Colors.textColorGray};
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const Title = styled.h3`
  ${FontSize18};
  font-weight: 500;
  text-align: center;
  margin: ${values.xsmall};
`

export const Description = styled.p`
  ${FontSize14};
  color: ${({ theme }) => theme.Colors.textColorGray};
  margin: ${values.xsmall};
`

export const Subtext = styled.p`
  ${FontSize12};
  margin: ${values.xsmall};
`

export const FooterInfo = styled.p`
  ${FontSize12};
  text-align: left;
  font-weight: 400;
  color: ${({ theme }) => theme.Colors.textColorGray};
  padding-left: ${values.xsmall};
`

export const Subtitle = styled.span`
  font-weight: bold;
`

export const Link = styled.a`
  color: ${({ theme }) => theme.Colors.forFonts.fColor13};
  text-decoration: none;
`

export const SVGMargin = styled.svg`
  padding: ${values.xsmall};
`

export const XIcon = () => (
  <SVGMargin
    width="52px"
    height="52px"
    viewBox="0 0 52 52"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group 2</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="08" transform="translate(-614.000000, -110.000000)">
        <g id="Group-2" transform="translate(614.000000, 110.000000)">
          <circle id="Oval" fill="#FF644F" cx="26" cy="26" r="26" />
          <rect
            id="Rectangle-765"
            fill="#FFFFFF"
            transform="translate(25.604172, 26.302840) rotate(45.000000) translate(-25.604172, -26.302840) "
            x="22.8958383"
            y="14.3861731"
            width="5.41666667"
            height="23.8333333"
            rx="2.70833333"
          />
          <rect
            id="Rectangle-765-Copy"
            fill="#FFFFFF"
            transform="translate(25.604172, 26.302840) scale(-1, 1) rotate(45.000000) translate(-25.604172, -26.302840) "
            x="22.8958383"
            y="14.3861731"
            width="5.41666667"
            height="23.8333333"
            rx="2.70833333"
          />
        </g>
      </g>
    </g>
  </SVGMargin>
)

export const Check = () => (
  <SVGMargin
    width="52px"
    height="52px"
    viewBox="0 0 52 52"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group 2</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="02" transform="translate(-636.000000, -110.000000)">
        <g id="Group-2" transform="translate(636.000000, 110.000000)">
          <circle id="Oval" fill="#4DC66D" cx="26" cy="26" r="26" />
          <path
            d="M29.751316,35.8112536 C29.6424261,35.8258161 29.5313432,35.8333333 29.4185428,35.8333333 L22.4981238,35.8333333 C21.1184481,35.8333333 20,34.7109965 20,33.3311215 L20,32.9188785 C20,31.5369451 21.1210911,30.4166667 22.4981238,30.4166667 L27.5833333,30.4166667 L27.5833333,14.505538 C27.5833333,13.1217676 28.7056702,12 30.0855452,12 L30.4977882,12 C31.8797216,12 33,13.1175643 33,14.505538 L33,33.3277953 C33,34.7115658 31.8776632,35.8333333 30.4977882,35.8333333 L30.0855452,35.8333333 C29.972218,35.8333333 29.8606504,35.8258177 29.751316,35.8112536 Z"
            id="Rectangle-765"
            fill="#FFFFFF"
            transform="translate(26.500000, 23.916667) rotate(39.000000) translate(-26.500000, -23.916667) "
          />
        </g>
      </g>
    </g>
  </SVGMargin>
)
